import { Download } from "lucide-react";
import { motion } from "framer-motion";

// Desestructuramos { url } de las props
export default function Brochure({ url }) {
  // Si no hay url, retornamos null (el componente no se dibuja)
  if (!url) return null;

  const styles = {
    banner: {
      width: "60%",
      borderRadius: "20px",
      background: "linear-gradient(90deg, #004270, #4338ca)",
      padding: "10px 20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    text: {
      color: "#ffffff",
      fontSize: "18px",
      fontWeight: 600,
      textAlign: "center",
    },
    button: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "16px",
      padding: "14px 24px",
      borderRadius: "16px",
      background: "#ffffff",
      color: "#004270",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
      fontWeight: 500,
      textDecoration: "none", // Asegura que el link no tenga subrayado
    },
  };

  return (
    <div className="layout8">
      {/* Se eliminó styles.container si no está definido, 
          puedes envolverlo en un div simple o definir el estilo */}
      <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={styles.banner}
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            style={styles.text}
          >
            Descarga nuestro brochure informativo
          </motion.p>

          <motion.a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.button}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div
              animate={{ y: [0, -4, 0] }}
              transition={{ repeat: Infinity, duration: 1.2 }}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Download size={20} />
            </motion.div>
            Descargar
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
}